import React, { useState, useEffect } from "react";
import { Container, Col, Row } from "bootstrap-4-react";

import * as apiUrl from "../../apiUrl";

function CommunityInnerpageLocation({ title, description, cards }) {


  const Cards = cards
    ? JSON.parse(cards)
    : [];

  const chunkedCards = [];
  for (let i = 0; i < Cards.length; i += 5) {
    chunkedCards.push(Cards.slice(i, i + 5));
  }

  return (
    <section className="communitylocation-sec" id="homelocation-sec">
      <Container fluid>
        <Row className="flex-center">
          <Col md={10}>
            <div className="construction-parallax-sec">
              <Row className="banner-text-center">
                <Col md={10}>
                  <div className="heading-div">
                    <h1 className="common-head darkGrey" data-aos="fade-up">
                      {title}
                    </h1>
                    <p className="common-para" data-aos="fade-up">
                      {description}
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid className="wrap communitylocation-container">
        <Row className="locations-spacing-row">
          <Col
            md={12}
            lg={12}
            xl={12}
            sm={12}
            className="locations-spacing-col"
          >
            {chunkedCards.map((cardGroup, rowIndex) => (
              <Row className="locations-images-row" key={`row-${rowIndex}`}>
                {cardGroup.map((card, colIndex) => (
                  <Col
                    md={2}
                    className="locations-images-col"
                    key={`card-${card.id || colIndex}`}
                  >
                    <div
                      className="locations-images-div loc-img1"
                      data-aos="fade-up"
                    >
                      <img
                        src={`${apiUrl.apiUrl}/${card.location_image}`}
                        className="img-fluid"
                        alt={card.location_name}
                      />
                      <span className="time-text">{card.time}</span>
                    </div>
                    <div className="location-bottom-text" data-aos="fade-up">
                      <p>{card.location_name}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default CommunityInnerpageLocation;
